import { render, staticRenderFns } from "./index.vue?vue&type=template&id=616e3191&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616e3191')) {
      api.createRecord('616e3191', component.options)
    } else {
      api.reload('616e3191', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=616e3191&", function () {
      api.rerender('616e3191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabMenu/index.vue"
export default component.exports